<style scoped>
.addMargin {
  margin-top: 10px;
}
.grayOut {
  /* background: #f2f2f2; */
  color: rgb(170, 170, 170);
}
.ivu-avatar-large.ivu-avatar-icon {
  border-radius: 0;
}

.resource-container {
  display: flex;
  padding: 10px;
  background: #fff;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  /* align-items: center; */
}

.resource-avatar {
  margin-right: 10px;
}

.resource-body {
  /* overflow: hidden; */
  display: flex;
  width: calc(100% - 75px);
  /* justify-content: space-between; */
  /* align-items: center; */
}

.resource-content > h3 {
  /* white-space: nowrap; */
  font-weight: 300;
  width: 100%;
  /* overflow: hidden; */
  /* text-overflow: ellipsis; */
}

.resource-content {
  overflow: hidden;
  margin-right: 30px;
}
</style>

<template>
  <app-layout class="resource-menu-page-template">
    <Card style="border-radius:0" v-if="false" :padding="0" bordered shadow>
      <Row type="flex">
        <i-col :span="12" v-for="item in discover" :key="item.id">
          <div style="text-align:center;padding:15px" @click="redirectExtras(item)">
            <span style="padding:2px;border:1px solid #ddd;display:inline-block;border-radius:5px">
              <Avatar
                :src="menuPreviewImage(item)"
                style="width:100px;height:100px;border-radius:5px"
              />
            </span>
            <p>{{ item.title }}</p>
          </div>
        </i-col>
      </Row>
    </Card>
    <Row type="flex" justify="center">
      <!-- <i-col :span="24">
        <PlanFeaturedActivity ltype="discover"></PlanFeaturedActivity>
      </i-col>-->
      <i-col :span="24" v-for="item in discover" :key="item.id">
        <div
          class="resource-container pointer"
          v-on:click="$store.dispatch('statistics/postStats', {stat_type: 'link', link_tag: item.title });redirectExtras(item)"
          v-if="!isLink(item)"
        >
          <div class="resource-avatar">
            <Avatar
              :src="menuPreviewImage(item)"
              style="width:70px;height:70px"
              shape="square"
              size="large"
            ></Avatar>
          </div>
          <div class="resource-body">
            <div class="resource-content">
              <h3>{{ item.title }}</h3>
            </div>
          </div>
        </div>
        <a
          :href="link(item)"
          :target="link(item) != '#' ? '_blank' : '_self'"
          class="resource-container"
          style="color: #657180"
          v-else
        >
          <div class="resource-avatar">
            <Avatar
              :src="menuPreviewImage(item)"
              style="width:70px;height:70px"
              shape="square"
              size="large"
            ></Avatar>
          </div>
          <div class="resource-body">
            <div class="resource-content">
              <h3>{{ item.title }}</h3>
            </div>
          </div>
        </a>
      </i-col>
      <!-- <i-col v-if="discover.length != 0" :span="24" v-for="(item,k) in menuList" :key="k" :class="(item.break) ? 'addMargin': ''">
        <div class="resource-container" v-on:click="view(item)">
          <div class="resource-avatar">
            <Avatar :src="item.icon" size="large"></Avatar>
          </div>
          <div class="resource-body">
            <div class="resource-content">
                <h3>{{item.label}}</h3>
            </div>
          </div>
        </div>
      </i-col>-->
    </Row>
  </app-layout>
</template>

<script>
import VueCookie from "vue-cookie";
import PlanFeaturedActivity from "@/components/GroupFeatureActivity";
import _ from "lodash";
import Utils from "@/utils.js";
import Cons from "@/constants.json";
import { mapGetters } from "vuex";

export default {
  name: "ResourceMenuComponent",
  data() {
    return {
      menuList: [
        {
          icon: require("@/assets/resources/people.png"),
          label: "People",
          link: "/people",
        },
        // { icon: require('@/assets/resources/Organizations.png'), label: 'Organizations', link: '/organization' },
        // { icon: require('@/assets/resources/Special-Projects.png'), label: 'Special Projects', link: '/resources/list?type=special_project' },
        // { icon: require('@/assets/resources/City.png'), label: 'City', link: '/resources/list?type=city' },
        // { icon: require('@/assets/resources/Region.png'), label: 'Region', link: '/resources/list?type=region' },
        // { icon: require('@/assets/resources/Province.png'), label: 'Province', link: '/resources/list?type=province' },
      ],
    };
  },
  components: {
    PlanFeaturedActivity,
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    userInfo: {
      get() {
        return this.$store.state.user.info;
      },
    },
    isMobile: {
      get() {
        return this.$store.state.isMobile;
      },
    },
    discover: {
      get() {
        // return _.orderBy(this.$store.state.resource.resources.discover.pages, 'order')
        return _.orderBy(
          this.$store.state.resource.resources.discover,
          "order"
        );
      },
    },
  },
  mounted() {
    this.$store.dispatch("resource/getDiscover");
    this.$store.dispatch("feature/getDiscoverFeaturedActivity", {
      id: Cons[0].GROUP_ID.discover,
    });
  },
  methods: {
    customUrlAction(v) {
      switch (v.data.attachment_type) {
        case "link":
          let url = v.data.url;
          if (v.data.url.includes("{userId}")) {
            url = url.replace(/{userId}/g, this.userInfo.id);
          }

          if (this.brandInfo.generic_id) {
            if (
              this.brandInfo.generic_id.slug &&
              v.data.url.includes(`{${this.brandInfo.generic_id.slug}}`)
            )
              if (this.userInfo.generic_id) {
                let rgx = `{${this.brandInfo.generic_id.slug}}`;
                url = url.replace(rgx, this.userInfo.generic_id);
              } else
                url = url.replace(
                  /[{generic_id}|{genericId}]/g,
                  this.userInfo.generic_id
                );
          } else {
            if (
              v.data.url.includes("{generic_id}") ||
              v.data.url.includes("{genericId}")
            ) {
              if (this.userInfo.generic_id) {
                url = url.replace(
                  /[{generic_id}|{genericId}]/g,
                  this.userInfo.generic_id
                );
              }
            }
          }

          if (v.data.url.includes("{studentId}")) {
            if (this.userInfo.generic_id) {
              url = url.replace(/{studentId}/g, this.userInfo.generic_id);
            }
          }
          if (v.data.url.includes("{appName}")) {
            url = url.replace(/{appName}/g, this.brandInfo.title);
          }
          if (v.data.url.includes("{generic_email}")) {
            url = url.replace(/{generic_email}/g, this.userInfo.generic_email);
          }
          if (v.data.url.includes("{generic_mobile_number}")) {
            url = url.replace(/{generic_mobile_number}/g, this.userInfo.generic_mobile_number);
          }
          return url;
          break;
      }
    },
    menuPreviewImage(act) {
      if (act.thumbnail_photo_uri) {
        return Utils.getDisplayImage("activity_thumbnail", act, "medium");
      } else {
        if (act.cover_photo) {
          return Utils.getDisplayImage("activity", act, "medium");
        } else {
          if (act.type === "add_ons") {
            if (!act.cover_photo) {
              if (act.data.add_on_slug === "events")
                return require("@/assets/resources/Events.png");
              if (act.data.add_on_slug === "videos")
                return require("@/assets/resources/Videos.png");
              if (act.data.add_on_slug === "faq")
                return require("@/assets/resources/FAQ.png");
            } else {
              return Utils.getDisplayImage("activity", act, "medium");
            }
          }
        }
      }
    },
    viewPage(v) {
      this.$router.push({ path: v });
    },
    isLink(item) {
      let hasGenericId = this.userInfo.generic_id;
      let hasGenericIdUrl = false;
      let isLinkType =
        item.type == "attachment" && item.data.attachment_type == "link";
      let genericIdSlug = _.get(this.brandInfo, "generic_id.slug", null)

      if (isLinkType)
        hasGenericIdUrl = genericIdSlug ? item.data.url.includes("{" + genericIdSlug + "}") : false

      if (isLinkType && !hasGenericIdUrl) return true;
      else if (isLinkType && hasGenericIdUrl && !hasGenericId) return false;
      else return isLinkType;
    },
    link(item) {
      return this.customUrlAction(item);
    },
    redirectExtras(item) {
      if (item.type == "sub_menu") {
        this.$router.push({
          path: "/submenu/" + item.data.group_id,
          meta: { title: item.title },
        });
        return false;
      }

      if (item.type == "group_page") {
        this.$router.push({
          path: "/resources/" + item.data.careplan_id + "?tab=posts",
        });
        return false;
      }

      if (item.type == "module_page") {
        this.$router.push({
          path: "/module/" + item.data.module_id + "?floating=true&tab=course",
        });
        return false;
      }

      if (item.type == "element_page") {
        this.$router.push({ path: "/feed/" + item.data.element_id });
        return false;
      }

      if (item.type == "group_page_type") {
        let t = item.data.group_type;

        if (t == "organization") {
          this.$router.push({ path: "/group-type/organization" });
          // this.$router.push({ path: '/organization-list/'})
          return false;
        }

        this.$router.push({ path: "/group-type/" + t });
        return false;
      }

      if (item.type == "attachment") {
        if (!this.isLink(item)) BroadcastEvent.$emit("ADDONMENU", item);
        return false;
      }

      if (item.type == "add_ons") {
        BroadcastEvent.$emit("ADDONMENU", item);
        if (item.data.add_on_slug === "brand")
          this.$router.push({ path: "/organization-list" });
        // if( item.data.add_on_slug === 'events')
        //   this.$router.push({ path: '/events' })
        // if( item.data.add_on_slug === 'videos')
        //   this.$router.push({ path: '/videos' })
        // if( item.data.add_on_slug === 'faq')
        //   this.$router.push({ path: '/faq' })
        // if( item.data.add_on_slug === 'people')
        //   this.$router.push({ path: '/people-menu' })
        return false;
      }

      if (item.type != "hybrid")
        this.$router.push({ path: "/feed/" + item.id });
      else BroadcastEvent.$emit("ADDONMENU", item);;
    },
    view(item) {
      this.$router.push({ path: item.link });
    },
  },
};
</script>
